// @ts-ignore
import Locally from 'locallyjs';

/**
 * Local storage instance.
 *
 * @see https://www.npmjs.com/package/locallyjs
 *
 * @example
 * localStore.set('foo', 'bar');
 */
export const localStore = new Locally.Store({
	// DAM-19220 - set to false
	compress: false,
});

export default localStore;

import {setGlobal} from '@netx/core-next/utils/setGlobal';
if (process.env.NODE_ENV !== 'production') {
	setGlobal({localStore});
}
